import React, { useState } from 'react';
import styled from 'styled-components';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Sidebar from './sidebar/Sidebar';
import ContentComponent from './ContentComponent';
import HeaderComponent from './header/HeaderComponent';
import BackTopButton from 'components/button/BackTopButton';
import { theme } from 'utils/style/theme';

/**
 * * 사이드바 있는 레이아웃
 */

interface IProps {
  children: JSX.Element[] | JSX.Element; // 하위 개체들
  projectType?: string;
  style?: React.CSSProperties;
}
const DefaultLayout = ({ children, style }: IProps) => {
  const [cookies, setCookie] = useCookies();
  // console.log(cookies);
  const location = useLocation();
  const pathlocation = location.pathname.split('/');
  const menuname = `/${pathlocation[1]}`;

  const [collapsed, setCollapsed] = useState<boolean>(
    cookies?.collapsed === undefined ? false : JSON.parse(cookies.collapsed),
  );

  const [selectMenu, setSelectMenu] = useState<string>(
    menuname === '/' ? '/story' : menuname,
  );

  /// 사이드바 접기 펴기
  const handleCollapse = () => {
    setCollapsed(!collapsed);
    setCookie('collapsed', JSON.stringify(!collapsed));
  };

  /// 대메뉴 열고 닫기
  const handleOpenChange = (key) => {
    console.log(`DetailLayout : handleOpenChange : `, key);

    setCookie('openMenu', JSON.stringify(key), { expires: 0 } as any); // 대메뉴 열려있고, 선택된거 담기
  };
  /// 메뉴 선택하기
  const handleSelectedMenu = ({ key }) => {
    setCookie('currentPage', Number(1), { expires: 0 } as any); // 메뉴를 선택하면 1page로 다시 담는다.
    setCookie('server', 'test', { expires: 0 } as any);
    if (location.pathname === '/' && selectMenu === '/story') {
      setSelectMenu(key);
      setCookie('currentMenu', JSON.stringify(key), { expires: 0 } as any);
    }
    if (location.pathname !== '/') {
      setSelectMenu(key);
      // setCollapsed(!collapsed);
    }
  };
  return (
    <>
      <LayoutStyle hasSider style={style}>
        <Sidebar
          collapsed={collapsed}
          onCollapse={handleCollapse}
          onOpenChange={handleOpenChange}
          onSelect={handleSelectedMenu}
          selectMenu={selectMenu}
          handleCollapse={handleCollapse}
        />

        <LayoutContentStyle $collapsed={collapsed}>
          <HeaderComponent
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleCollapse={handleCollapse}
          />
          <ContentComponent>{children}</ContentComponent>
        </LayoutContentStyle>

        {/* 화면 top으로 이동 버튼 */}
        <BackTopButton />
      </LayoutStyle>
    </>
  );
};
export default DefaultLayout;
const LayoutStyle = styled(Layout)`
  min-height: 100vh;
  font-weight: 500;
  overflow: hidden;

  .ant-table table tr {
    vertical-align: middle;
  }
  .ant-table-pagination.ant-pagination,
  .ant-table-pagination-right {
    /* background: blue; */
    > li {
      border: none;
    }
    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      border: none;
    }
  }
  /* width가 100%인 그레이 박스 활용 (ex)사운드관리, 인트로, 등급제 등) */
  .full_grayBox {
    > div {
      width: 100%;
    }
  }
  .intro {
    .input_container {
      display: flex;
      transform: translate(-2.75rem, -1rem);
    }
    > div {
      display: flex;
      overflow: visible;
      th,
      td {
        padding: 0;
        padding-right: 0.5rem;
      }
      tr {
        /* border: solid 2px blue; */
        /* width: 22rem; */
        &:last-child {
          .ant-select {
            width: 10rem;
          }
        }
      }
      th {
        width: 10rem;
      }
      td {
        width: 13.5rem;
      }
      tr {
        margin-right: 1rem;
      }
      .title {
        width: 5rem;
        text-align: center;
      }
      .ant-input-affix-wrapper-borderless {
        width: 15rem;
      }
    }
  }
  .statusTag {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 6px;
    border-radius: 8px;
    border: 1px solid ${theme.colors.yellow_500};
    background: var(--foundation-yellow-yellow-50, #fef5eb);
    width: fit-content;
    margin-bottom: 6px;
    p {
      color: ${theme.colors.yellow_500} !important;
      font-size: ${theme.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.fontWeights.normal};
      line-height: 20px; /* 166.667% */
      letter-spacing: 0.2px;
    }
  }

  .sortWrapper {
    display: flex;
    align-items: center;
    & > * + * {
      margin-left: 4px;
    }
  }
  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
    border: none;
    background-color: white;
    border-bottom: 1px solid #f0f0f0;
  }
  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active {
    border-bottom: 2px solid ${theme.colors.blue_500};
  }
`;

const LayoutContentStyle = styled(Layout)<{ $collapsed?: boolean }>`
  padding: 0rem 1.5rem;
  /* transition: all 0.5s; */
  transition-property: margin-left;
  transition-duration: 0.5s, 0.5s;
  margin-left: ${(props) => (props.$collapsed ? '80px' : '268px')};
  min-height: 100vh;
  padding: 24px;
`;
